export default "__VITE_ASSET__DXyanbdN__"